import * as _ from 'lodash';
import usePrevious from '@nkr/services/use-previous';
import { FormEvent, useEffect, useState } from 'react';
import { Button, ButtonToolbar, FormControl, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';

interface IProps {
    firstName: string,
    lastName: string,
    email: string,
    alias: string,
    buttons: number[],
    onRefresh: (firstName: string, lastName: string, email: string, alias: string, buttons: number[]) => void
}

const Filter = (props: IProps) => {
    const [firstName, setFirstName] = useState(props.firstName);
    const [lastName, setLastName] = useState(props.lastName);
    const [email, setEmail] = useState(props.email);
    const [alias, setAlias] = useState(props.alias);
    const [buttons, setButtons] = useState(props.buttons);

    const previousProps = usePrevious(props);

    useEffect(() => {
        if (_.isEqual(previousProps, props) == false) {
            setFirstName(props.firstName);
            setLastName(props.lastName);
            setEmail(props.email);
            setAlias(props.alias);
            setButtons(props.buttons);
        }
    }, [props]);

    const handleChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let property = e.currentTarget.name;
        let value = e.currentTarget.value;

        if (property == 'firstName') {
            setFirstName(value);
        }

        if (property == 'lastName') {
            setLastName(value);
        }

        if (property == 'email') {
            setEmail(value);
        }

        if (property == 'alias') {
            setAlias(value);
        }
    };

    const handleButtonChange = (e: any, button: number) => {
        e.preventDefault();
        let newButtons = [...buttons];
     
        newButtons[button] = newButtons[button] > 0? 0: 1;
        setButtons(newButtons);
    };

    const handleRefresh = () => {
        props.onRefresh(firstName, lastName, email, alias, buttons);
    };

    let isAvailable = buttons[0] > 0;
    let isNotAvailable = buttons[1] > 0;
    let enableRefresh = isAvailable == true || isNotAvailable == true ? true : false;

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                    <div style={{ marginRight: 5 }}>First Name:</div>
                    <FormControl
                        name='firstName'
                        style={{ width: 120 }}
                        value={firstName}
                        onChange={handleChange}
                    />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                    <div style={{ marginRight: 5 }}>Last Name:</div>
                    <FormControl
                        name='lastName'
                        style={{ width: 120 }}
                        value={lastName}
                        onChange={handleChange}
                    />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                    <div style={{ marginRight: 5 }}>Email:</div>
                    <FormControl
                        name='email'
                        style={{ width: 120 }}
                        value={email}
                        onChange={handleChange}
                    />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                    <div style={{ marginRight: 5 }}>Alias:</div>
                    <FormControl
                        name='alias'
                        style={{ width: 120 }}
                        value={alias}
                        onChange={handleChange}
                    />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                    <div style={{ marginRight: 5 }}>Status:</div>
                    <div>
                        <ButtonToolbar>
                            <ToggleButtonGroup type="checkbox">
                                <ToggleButton value={props.buttons[0]} className={isAvailable ? 'btn-primary' : 'btn'} onClick={(e) => handleButtonChange(e, 0)}>Available</ToggleButton>
                                <ToggleButton value={props.buttons[1]} className={isNotAvailable ? 'btn-primary' : 'btn'} onClick={(e) => handleButtonChange(e, 1)}>Unavailable</ToggleButton>
                            </ToggleButtonGroup>
                        </ButtonToolbar>
                    </div>
                </div>
            </div>

            <Button disabled={!enableRefresh} bsStyle='primary' onClick={handleRefresh}>Refresh List</Button>
        </div>
    );
}

export default Filter;